'use client';
import { createBrowserClient } from '@supabase/ssr';

import { LELAND_DOMAIN } from '../constants';

// Create the initial client to get the proper type
const initialClient = createBrowserClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL ?? '',
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '',
  {
    auth: {
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    cookieOptions: {
      domain: LELAND_DOMAIN,
      path: '/',
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
    },
  },
);

// Singleton client instance with proper typing
let client: typeof initialClient | null = initialClient;

export function createClient(): typeof initialClient {
  // Return existing client if already created
  if (client) {
    return client;
  }

  // This should never happen since we initialize above, but TypeScript needs it
  client = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL ?? '',
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '',
    {
      auth: {
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
      cookieOptions: {
        domain: LELAND_DOMAIN,
        path: '/',
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'lax',
      },
    },
  );

  return client;
}
